<template>
  <div>
    <modal-box :is-active="isModalActive" :trash-object-name="trashObjectName" @confirm="trashConfirm" @cancel="trashCancel"/>
    <b-table
      :data="isEmpty ? [] : offersRejected"
      :paginated="isPaginated"
      :per-page="perPage"
      :current-page.sync="currentPage"
      :pagination-position="paginationPosition"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page">

      <b-table-column label="#ID" field="id" v-slot="props">
        <small class="has-text-grey is-abbr-like" :title="props.row.id">{{ props.row.id }}</small>
      </b-table-column>
      <b-table-column label="Nomor Penawaran" field="reference_code" v-slot="props">
        <small class="has-text-grey is-abbr-like" :title="props.row.reference_code">{{ props.row.reference_code }}</small>
      </b-table-column>
      <b-table-column label="Client" v-slot="props">
        <small class="has-text-grey is-abbr-like" :title="props.row.client_name">{{ props.row.client_name }}</small>
      </b-table-column>
      <b-table-column label="Created By" field="created_by" v-slot="props">
        {{ props.row.created_by }}
      </b-table-column>
      <b-table-column label="Notes" field="note" v-slot="props">
        <p v-if="props.row.note !== null"> {{ props.row.note }}</p>
        <p v-else> - </p>
      </b-table-column>
      <b-table-column label="Status" v-slot="props">
        <small class="has-text-grey is-abbr-like" :title="props.row.status">
          <span class="tag is-danger">
            <p v-if="props.row.status === 2"> REJECTED </p>
          </span>
        </small>
      </b-table-column>
      <b-table-column label="Action" custom-key="actions" cell-class="is-actions-cell" v-slot="props">
        <div class="buttons is-centered">
          <div class="button is-small is-warning" @click="updateOnClick(props.row.id)">
            <b-icon icon="pencil" size="is-small"/>
          </div>
        </div>
      </b-table-column>

      <section class="section" slot="empty">
        <div class="content has-text-grey has-text-centered">
          <template>
            <p>
              <b-icon icon="alert-outline" size="is-large"/>
            </p>
            <p>No data here&hellip;</p>
          </template>
        </div>
      </section>
    </b-table>
  </div>
</template>

<script>
// import axios from 'axios'
import { mapGetters } from 'vuex'
import ModalBox from '@/components/ModalBox'

export default {
  name: 'OfferTableRejected',
  components: { ModalBox },
  data () {
    return {
      isModalActive: false,
      trashObject: null,
      isLoading: false,
      isPaginated: true,
      isPaginationSimple: true,
      isPaginationRounded: true,
      currentPage: 1,
      perPage: 5,
      paginationPosition: 'bottom',
      isEmpty: false
    }
  },
  computed: {
    trashObjectName () {
      if (this.trashObject) {
        return this.trashObject.name
      }
      return null
    },
    ...mapGetters({
      offersRejected: 'penawaran/getListRejected'
    })
  },
  props: { initData: Array },
  watch: {
    initData (newVal) {
      if (newVal.length > 0) {
        this.offersRejected = newVal
      } else {
        this.isEmpty = true
      }
    }
  },
  methods: {
    updateOnClick (v) {
      this.$router.push({
        path: `penawaran/update/${v}`
      })
    },
    detailOnClick (v) {
      this.$router.push({
        path: `/penawaran/detail/${v}/Rejected`
      })
    },
    trashModal (trashObject) {
      this.trashObject = trashObject
      this.isModalActive = true
    },
    trashConfirm () {
      this.isModalActive = false
      this.$buefy.snackbar.open({
        message: 'Confirmed',
        queue: false
      })
    },
    trashCancel () {
      this.isModalActive = false
    }
  },
  mounted () {},
  created () {}
}
</script>
